<template>
    <div class="vertical-container vertical-container--in-secondary-content">
        <div class="vertical-container__header vertical-container__header--has-shadow">
            <div class="container">
                <h1>Soubory</h1>
            </div>
        </div>

        <div class="vertical-container__content">
            <div class="elementary-section">
                <div class="elementary-section__in">
                    <div class="container">
                        <file-media-container/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainContainer from '@/modules/ProjectModule/modules/OptionModule/components/Main/MainContainer';
import FileMediaContainer from 'domovio-core/src/modules/MediaModule/components/File/FileContainer';

export default {
    name:       'ProjectFileView',
    components: { FileMediaContainer, MainContainer },
}
</script>
